import { ofType, combineEpics } from 'redux-observable';
import { asyncScheduler } from 'rxjs';
import { observeOn, takeUntil } from 'rxjs/operators';
import { CLEAR_ACTIVE_INTERFACE, SET_ACTIVE_INTERFACE } from '../app/actions';

const combineInterfaceEpics = (...epics) => (action$, ...rest) =>
   combineEpics(...epics)(action$, ...rest).pipe(
      takeUntil(
         action$.pipe(
            ofType(SET_ACTIVE_INTERFACE, CLEAR_ACTIVE_INTERFACE),
            // Async here allows clean up of interface epics on these events
            observeOn(asyncScheduler)
         )
      )
   );

export { combineInterfaceEpics };
